var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPisces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pisces") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pisces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Bar",
    fill: "#000000",
    points: "5 13.7993 19 13.7993 19 11.7993 5 11.7993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,12.7992 C10,7.9612 6.564,3.9272 2,3.0002 L2,4.9642 C5.498,5.8582 8.095,9.0272 8.095,12.7992 C8.095,16.5712 5.498,19.7402 2,20.6342 L2,22.5982 C6.564,21.6712 10,17.6372 10,12.7992",
    id: "Fish",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12.7992 C14,17.6372 17,21.6712 22,22.5982 L22,20.6342 C19,19.7402 15.905,16.5712 15.905,12.7992 C15.905,9.0272 18.502,5.8582 22,4.9642 L22,3.0002 C17.436,3.9272 14,7.9612 14,12.7992",
    id: "Fish",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisces);
export default __webpack_public_path__ + "static/media/pisces.464efdc33e20b18c290cf8acff119936.svg";
export { ForwardRef as ReactComponent };